import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class VoucherMessageChannelNextVoucherForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'kanal-bilagsnumre', dataApiName: 'VoucherMessageChannelNextVoucher', text: 'Bilagsnumre',
        primaryKey: 'id', titleFields: ['year'], baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'channelId', text: 'Kanal', tooltipText: 'Bilagskanal', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyTableName: 'VoucherMessageChannel', orderBy: 'Ascending' },
        { name: 'year', text: 'År', tooltipText: 'År for bilagsserie', required: true, allowEdit: true, allowEditOnAdd: true, format: 'Integer', orderBy: 'Descending' },
        { name: 'maskVoucher', text: 'Maske', tooltipText: 'Bilagserie formattering', allowEdit: true, defaultValue: '', allowEditOnAdd: true, widthType: FieldWidthEnum.M, visible: false },
        { name: 'nextVoucher', text: 'Næste nr', tooltipText: 'Næste bilagsnr.', required: true, allowEdit: true, allowEditOnAdd: true, format: 'Number' },
      ]
    });
  }
}
